module.exports = __webpack_public_path__ + "static/Voog-dc9a8254a4ea2281736b0be09e5410df.png";